import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    newContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    newFields: {
      display: 'grid',
      gridTemplateColumns: '3fr 3fr 4fr',
      gap: theme.spacing(2),
      alignItems: 'start',
    },
    newInventoryNumber: { display: 'flex', alignItems: 'start' },
  };
};
